<template>
  <v-app>
    <PublicHeader/>
    <v-main>
      <v-container fluid>
          <div class="cycle-container">
            <div class="cycle">
              <transition name="product">
                <div class="mt-10" v-show="logoControl">
                  <v-row>
                    <v-col class="mt-10">
                      <div class="mt-10 pt-10 font-weight-light text-center text-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4">Ravenpod</div>
                      <div class="font-weight-medium text-center text-h1 text-sm-h1 text-md-h1 text-lg-h1 text-xl-h1 indigo--text darken-4">Sapphire</div>
                      <div class="mt-5 font-weight-light text-center text-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5">Coming soon...</div>
                    </v-col>
                  </v-row>
                </div>
              </transition>
            </div>
          </div>
      </v-container>
    </v-main>
    <Footer/>
  </v-app>
</template>

<script>

  import Footer from '@/components/Footer.vue'
  import PublicHeader from '@/components/PublicHeader.vue'

  export default {
      components: {
        PublicHeader, Footer
      },
      data() {
          return {
            colors: [
              'primary',
              'secondary',
              'yellow darken-2',
              'red',
              'orange',
            ],            
            logoControl: false
          };
      },
      computed: {
      },
      mounted() {

        setTimeout(() => {
          this.logoControl = true // Make logo to fade in after mounted for 1250ms
        }, 1250);

      },
      methods: {
      }
  };

</script>

<style scoped lang="scss">

  .cycle-container {
    min-height: 720px;
    position: relative;
    width: 100%;
  }

  .cycle {
    width: 100%;
    position: absolute;
    top: 0;
  }

  .product-enter-active {
    transition: 5s;
  }

  .product-leave-active {
    transition: 4s;
  }

  .product-enter {
    opacity: 0;
  }

</style>


